const selectImages = state => state.data.images

const ImageDataStoreSelectors = {
  images: selectImages
}

export default ImageDataStoreSelectors
